export const readData = async (name:string) => {
  try {
    return await localStorage.getItem(name);
  } catch (e) {
    // error reading value
  }
};